import { PAX_TYPE } from "@app/enums";
import {
  BoardingPassInt, BoardingPassResponseInt,
  BookedLegInt,
  BookedTravelerCollectionInt,
   InfoWeatherInt,
  PNRCollectionInt,
   WeatherDataInt
} from "@app/interfaces";
import { CartPNRUpdate } from "@app/models/cart/cart-pnr-update.model";
import { Segment } from "@app/models/cart/segment.model";
import { Infant } from "@app/models/infant.model";
import { Passenger } from "@app/models/passenger.model";
import { Reservation } from "@app/models/reservation.model";
import {environment} from "@env/environment";
import {isNight} from "@app/utils";

export class PnrLookUpMapper {

  private static reservations: Reservation[];

  constructor() { }

  static pnrBuild(pnrLookUp: PNRCollectionInt,location: string) {
    this.reservations = [];
    let reservation: Reservation;
    if (pnrLookUp) {
      let carts = pnrLookUp.carts;
      let legs = pnrLookUp.legs;
      let kioskLocation = location//dataStore.getLocation();

      if (carts._collection.length > 0) {
        for (const cart of carts._collection) {
          const bookedLeg = legs._collection.find(x => x.segments.legCode === cart.legCode);
          if (bookedLeg) {
            const reservation = new Reservation({ 
              pnrCode: pnrLookUp.pnr, 
              cart, 
              leg: bookedLeg, 
              kioskLocation 
            });
        
            reservation.autoCheckin = pnrLookUp.autoCheckin;
            reservation.flightItineraryType = pnrLookUp.flightItineraryType;
            reservation.tsaRequired = pnrLookUp.tsaRequired;
        
            if (pnrLookUp.corporateRecognition) {
              reservation.corporateRecognition = pnrLookUp.corporateRecognition;
              if (pnrLookUp.corporateRecognition.logo) {
                reservation.corporateRecognition.companyLogo = 
                  `${environment.cmsUrl}/sites/default/files/${pnrLookUp.corporateRecognition.spid}.png`;
              }
            }
        
            reservation.segments = this.buildFlightSegments(cart, bookedLeg);
            reservation.passengers = this.buildPassengers(cart);
            reservation.showGender = reservation.passengers.some(p => p.isSelectedToCheckin && (!p.gender || p.gender === ""));
            reservation.apiCart = new CartPNRUpdate({ reservation, apiCart: cart });
            reservation.isStandByBooking = this.isStandByBooking(reservation);
        
            this.reservations.push(reservation);
          }
        }
      } else {
        const leg = legs._collection[0];
        let cart: any = {
          legCode: leg.segments.legCode,
          _meta: {
            cartId: ''
          },
        };
        reservation = new Reservation({pnrCode: pnrLookUp.pnr, cart, leg, kioskLocation});
        reservation.passengers = [];//[{ ineligibleReasons: [] }];
        reservation.segments = this.buildFlightSegments(cart, leg);
        reservation.tsaRequired = pnrLookUp.tsaRequired
        reservation.flightItineraryType = pnrLookUp.flightItineraryType;
        if (pnrLookUp.corporateRecognition) {
          reservation.corporateRecognition = pnrLookUp.corporateRecognition;
          if (pnrLookUp.corporateRecognition && pnrLookUp.corporateRecognition.logo) {
            pnrLookUp.corporateRecognition.companyLogo =  `${environment.cmsUrl}/sites/default/files/${pnrLookUp.corporateRecognition.spid}.png`
          }
        }
        this.reservations.push(reservation);
      }
    }
    return this.reservations;
  }

  private static buildFlightSegments(cart: BookedTravelerCollectionInt, leg: BookedLegInt) {
    let segments: Segment[] = [];
    if (leg.segments?._collection) {
      for (const segment of leg.segments._collection) {
        const newSegment = new Segment({ cart, segment: segment.segment });
        newSegment.iropEligibility ??= this.valideElegibility(leg?.iropEligibility);
        segments.push(newSegment);
      }
    }
    return segments;
  }
  private static valideElegibility(iropEligibility) {
    if (iropEligibility) {
      iropEligibility.isEligibility = environment.isCert && !environment.production ? 
      true : iropEligibility.isEligibility;
    }
    return iropEligibility;
  }

  private static buildPassengers(cart:BookedTravelerCollectionInt) {
    let passengers: Passenger[] = [];
    let travelerInfo = cart.travelerInfo;
    if (travelerInfo && travelerInfo._collection && travelerInfo._collection.length > 0) {
      for (let passIndex = 0; passIndex < travelerInfo._collection.length; passIndex++) {
        let passengerInfo = travelerInfo._collection[passIndex];
        passengerInfo.legCode = cart.legCode;
        let passenger  = new Passenger(passengerInfo);
        passengers.push(passenger);
        if(passengerInfo.infant?.paxType == PAX_TYPE.INFANT){
          let infant  = new Infant(passengerInfo.infant,passenger);
          passengers.push(infant);
        }
      }
    }
    return passengers;
  }

  private static isStandByBooking(reservation) {
    let passengers = reservation.passengers;
    for (let index = 0; index < passengers.length; index++) {
      let passenger = passengers[index];
      if (passenger.passengerType === 'E') {
        return true;
      }
    }
    return false;
  }

  static mapBoardinPass(data: BoardingPassInt): {pectab: string, value: Array<string>, weatherInfo: WeatherDataInt} {
    let weatherInfo = undefined;
    if(data.dailyForecasts){
      weatherInfo = {
        unit: data.dailyForecasts.Temperature?.Maximum?.Unit,
        minTemp: data.dailyForecasts.Temperature?.Minimum?.Value,
        maxTemp: data.dailyForecasts.Temperature?.Maximum?.Value,
        dayIcon: data.dailyForecasts.Day?.Icon,
        nightIcon: data.dailyForecasts.Night?.Icon
      }
    }
    const boardinPasesInfo: {pectab: string, value: Array<string>, weatherInfo} = {
      pectab: data.pectabBoardingPassList[0].value,
      value: [],
      weatherInfo
    };

    for (const boardinPases of data._collection) {
      boardinPasesInfo.value.push(boardinPases.pectabFormat);
    }

    return boardinPasesInfo;
  }

  static mapWeatherInfo(bpInfo: BoardingPassResponseInt, segment: Segment): InfoWeatherInt{
    const arrivalTime = segment.arrivalTime
    let min;
    let max;
    let unit
    const weather = this.getIconWeather(bpInfo, arrivalTime  );

    unit = bpInfo?.weatherInfo.unit
    min = `${bpInfo?.weatherInfo.minTemp} °${unit}`;
    max = `${bpInfo?.weatherInfo.maxTemp} °${unit}`;
    
    return {
      weather,
      text: `${min} - ${max}`
    }
  }
  private  static getIconWeather( boardingPass: BoardingPassResponseInt, arrivalDate: string) {
    let icon = null
    if(boardingPass.weatherInfo) {
      const { dayIcon, nightIcon} = boardingPass.weatherInfo
      const  isNigh = isNight(arrivalDate);
      icon = `assets/images/weather/${ isNigh ? nightIcon:dayIcon  }.svg`;
    }

    return icon

  }
}
